import { useBidExpiryTimer } from '@/views/screens/AuctionScreens/hooks';

export const ExpiryTimer = ({ expiryDateTime }: { expiryDateTime: string }) => {
  const { bidExpiry } = useBidExpiryTimer(expiryDateTime);

  return bidExpiry;
};
